import axios from "axios";

const BASE = "/api/temp-aid";

export function lookup({ email } = {}) {
  return axios.post(`${BASE}/lookup`, { email });
}

export function create(data) {
  return axios.post(BASE, data);
}
